import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import AdminDash from "../Components/AdminDash/AdminDash";
import Search from "../Components/AdminDash/Search";
import ReaderView from "../Components/ReadStory/ReaderView";
import Report from "../Components/Report/Report";
import Stories from "../Components/Stories/Stories";
import StoryDetails from "../Components/AdminEdit/StoryDetails";
import Write from "../Components/Write/Write";
import { getInfo } from "../utils/hooks";

const AdminLayout: React.FC = () => {
    const userInfo = getInfo();

    if (userInfo === null) {
        return <Redirect to="/admin-login" />;
    }

    return (
        <Switch>
            <Route path="/admin/story/:id" component={StoryDetails} />
            <Route path="/admin/search" component={Search} />
            <Route exact path="" component={AdminDash} />
        </Switch>
    );
};

export default AdminLayout;
